

































import Vue from 'vue';
import SparkListItem from '@/vue-components/sparks/SparkListItem.vue';
import { SparkWebDAO } from '@/web';

export default Vue.extend({
  name: 'SparkList',
  components: {
    SparkListItem,
  },
  data() {
    return {
      emptyRefreshCount: 0,
      infiniteLoadState: {
        reset: () => {
          return;
        },
      },
    };
  },
  computed: {
    title(): string {
      return 'Sparkello';
    },
    sparks() {
      return this.$store.state.sparks;
    },
    sparksCache() {
      return this.$store.state.sparkCache;
    },
  },
  created() {
    SparkWebDAO.getInstance().refreshSparkCache();
  },
  mounted() {
    this.resetInfiniteScroll();
  },
  methods: {
    infiniteScrollHandler($state) {
      if (this.$store.state.sparkCache.isEmpty()) {
        if (this.emptyRefreshCount < 20) {
          const timeout = this.emptyRefreshCount > 1 ? 500 : 1000;
          console.log('Timeout', timeout);
          setTimeout(() => {
            this.emptyRefreshCount++;
            $state.loaded();
          }, timeout);
        } else {
          $state.error();
        }
      } else if (this.$store.state.sparkCache.addSparksToDisplay(24)) {
        console.log('New spark cache', this.$store.state.sparkCache);
        this.$store.commit('setSparkCache', this.$store.state.sparkCache);

        setTimeout(() => {
          this.emptyRefreshCount++;
          $state.loaded();
        }, 200);
      } else {
        $state.complete();
      }

      //Store a reference to the infiniteLoader state object so that I can reset it on a new page load
      this.infiniteLoadState = $state;
    },
    resetInfiniteScroll() {
      //Reset the infinite loader widget
      if (this.infiniteLoadState.reset) {
        this.infiniteLoadState.reset();
      }
    },
  },
})
;
